// extracted by mini-css-extract-plugin
export default {"PrimaryView":"PrimaryView_PrimaryView__AH119","PrimaryView__back":"PrimaryView_PrimaryView__back__1YNF6","PrimaryView__content":"PrimaryView_PrimaryView__content__3AQ0K"};